module.exports = __webpack_public_path__ + "static/img/label-02.3987e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/label-02.png
// module id = qLwH
// module chunks = 150